import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useValidator } from "react-joi";
import {
  addOrUpdateUser,
  deleteUser,
  getListUserAndRolByProject,
} from "actions/User";
import { getProfilesList } from "actions/Catalogs";
import Grid from "components/Grid";
import InputCustom from "components/InputCustom";
import Joi from "joi";
import Modal from "components/Modal";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import { notify } from "utils";
import { parseISO, format } from "date-fns/esm";
import {
  multiFilter,
  SelectColumnFilterStatus,
} from "components/SelectFilterStatus/SelectFilterStatus";

const Group = ({ view = {} }) => {
  const dispatch = useDispatch();
  const [t] = useTranslation("group");
  const [tc] = useTranslation("catalog");
  const [t2] = useTranslation("global");
  const { userList } = useSelector((state) => state.user);
  const { currentProject } = useSelector((state) => state.auth);
  const { permissions } = view;

  //auxiliares para abrir modales
  const [openModal, setOpenModal] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [projectsIds, setProjectsIds] = React.useState([]);
  const [isLoad, setIsLoad] = React.useState(false);

  const [id, setId] = React.useState();
  const buttonRef = React.useRef();
  const { state, setData, setExplicitField, validate } = useValidator({
    initialData: {
      name: null,
      description: null,
    },
    schema: Joi.object({
      name: Joi.string()
        .min(2)
        .max(50)
        .required()
        .messages({
          "string.empty": tc("error.empty"),
          "string.base": tc("error.type", { type: "string" }),
          "string.min": tc("error.min"),
          "string.max": tc("error.max", { quantity: "50" }),
          "any.required": tc("error.required"),
        }),

      description: Joi.string()
        .min(2)
        .max(50)
        .required()
        .messages({
          "string.empty": tc("error.empty"),
          "string.base": tc("error.type", { type: "string" }),
          "string.min": tc("error.min"),
          "string.max": tc("error.max", { quantity: "50" }),
          "any.required": tc("error.required"),
        }),
    }),
    explicitCheck: {
      name: false,
      description: false,
    },
    validationOptions: {
      abortEarly: true,
    },
  });

  //Insert or Edit
  const handleOnSubmit = async () => {
    if (state.$all_errors.length > 0 || state.$all_source_errors.length > 0) {
      setShowError(true);
      validate();
      notify("error", t("error.general_toast"), 1200);
      return;
    }

    if (projectsIds && projectsIds.length === 0) {
      notify("error", t("error.project"), 1200);
      return;
    }
    setIsLoad(true);
    if (buttonRef & buttonRef?.current) buttonRef.current.disabled = true;
    setShowError(false);
    // let isSuccess = await dispatch(
    //   addOrUpdateUser({
    //     email,
    //     name,
    //     lastName,
    //     secondLastName,
    //     id,
    //     idRole,
    //     idProject: currentProject.id,
    //     projects: projectsIds,
    //   })
    // );
    // if (buttonRef & buttonRef?.current) buttonRef.current.disabled = false;
    // setIsLoad(false);
    // if (isSuccess) {
    //   setData((old) => ({
    //     ...old,
    //     email: null,
    //     name: null,
    //     lastName: null,
    //     secondLastName: null,
    //     idRole: null,
    //   }));
    //   setId(null);
    //   setProjectsIds([]);
    //   setOpenModal(false);
    // }
  };

  //deleteUser
  const handleDelete = async (idUser) => {
    Swal.fire({
      title: t2("button.title"),
      text: t("delete"),
      icon: "error",
      confirmButtonText: t2("button.confirm"),
      cancelButtonText: t2("button.cancel"),
      cancelButtonColor: "#000000",
      confirmButtonColor: "#FF3447",
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed && idUser) {
        dispatch(deleteUser(idUser, currentProject.id));
      }
    });
  };

  const handleActive = async (data) => {
    let title = t("active.title_enable");
    let description = t("active.enable");

    if (data.user["active"]) {
      title = t("active.title_disable");
      description = t("active.disable");
    }

    Swal.fire({
      title: title,
      text: description,
      icon: "warning",
      confirmButtonText: t("active.btn_continue"),
      cancelButtonText: t("active.btn_cancel"),
      cancelButtonColor: "#000000",
      confirmButtonColor: "#FF3447",
      showCancelButton: true,
    }).then(async (result) => {
      if (result.isConfirmed && data) {
        let active = true;
        const { user } = data;
        const { id, name, email, lastName, secondLastName } = user;
        if (data.user["active"]) {
          active = false;
        }
        await dispatch(
          addOrUpdateUser({
            id,
            email,
            name,
            lastName,
            active,
            secondLastName,
            idProject: currentProject.id,
          })
        );
      }
    });
  };

  React.useEffect(() => {
    if (currentProject && currentProject?.id) {
      dispatch(getListUserAndRolByProject(currentProject.id));
    }
    dispatch(getProfilesList());
  }, [dispatch, currentProject]);

  function filterDate(rows, columnIds, filterValue) {
    return filterValue.length === 0
      ? rows
      : rows.filter((row) =>
          String(
            format(parseISO(row.original.user["updatedAt"]), "dd/MM/yyyy HH:mm")
          ).includes(filterValue)
        );
  }

  return (
    <>
      <Grid
        title={t("group.title")}
        columns={[
          {
            Header: "Id",
            accessor: "user.id",
            filter: "text",
            width: "12%",
          },

          {
            Header: t("group.name"),
            accessor: "user.name",
            filter: "text",
            width: "12%",
          },
          {
            Header: t("group.description"),
            accessor: "user.lastName",
            filter: "text",
            width: "12%",
          },

          {
            Header: "Status",
            accessor: "user.active",
            Filter: SelectColumnFilterStatus,
            filter: multiFilter,
            Cell: ({ value }) => {
              return value ? (
                <div className="flex items-center justify-center">
                  <div className="h-2 w-2 bg-green-500 rounded-full"></div>
                </div>
              ) : (
                <div className="flex items-center justify-center">
                  <div className="h-2 w-2 bg-red-500 rounded-full"></div>
                </div>
              );
            },
            width: "12%",
          },
          {
            Header: t("group.updated_at"),
            accessor: "user.updatedAt",
            filter: filterDate,
            Cell: ({ value }) => {
              if (value) return format(parseISO(value), "dd/MM/yyyy HH:mm");
              return value;
            },
            width: "10%",
          },
        ]}
        data={userList ? userList.filter((item) => item.idUser !== 1) : []}
        handleAdd={() => {
          setOpenModal(true);
          setProjectsIds([currentProject.id]);
        }}
        handleEdit={(row) => {
          const {
            user: { id, email, name, lastName, secondLastName },
            idRole,
            projects,
          } = row;
          setId(id);
          setData((old) => ({
            ...old,
            email,
            name,
            lastName,
            secondLastName,
            idRole,
          }));
          setProjectsIds(projects);
          setOpenModal(true);
        }}
        handleDelete={({ user: { id } }) => handleDelete(id)}
        write={permissions.write}
        AdditionalOptionsRows={({ row }) => {
          const { original } = row;
          return permissions?.write ? (
            <button
              className="text-sm text-left py-2 px-4 font-normal block w-full whitespace-nowrap bg-transparent text-blueGray-700 hover:bg-gray-200 hover:text-gray-900"
              onClick={() => {
                handleActive(original);
              }}
            >
              {original.user.active ? t("disable") : t("enable")}
            </button>
          ) : null;
        }}
      />

      {/*Main Modal */}
      {openModal ? (
        <Modal
          openModal={openModal}
          closeModal={() => {
            setData((old) => ({
              ...old,
              description: null,
              name: null,
            }));
            setShowError(false);
            setOpenModal(false);
            setId(null);
            setProjectsIds([]);
          }}
          titleModal={t("group.title")}
          onSubmit={handleOnSubmit}
          disableAdd={state.$invalid}
          iconEdit={id > 0 ? true : false}
          buttonRef={buttonRef}
          processFetch={isLoad}
        >
          <div className="flex flex-col ">
            <InputCustom
              type={"text"}
              labelText={t("group.name")}
              errorMessage={
                showError && state.$errors.name.length > 0
                  ? state.$errors.name[0].$message
                  : null
              }
              onBlur={() => setExplicitField("name", true)}
              onChange={(e) => {
                e.persist();
                setData((old) => ({
                  ...old,
                  name: e.target.value,
                }));
              }}
              value={state.$data.name}
              key="name"
              disabled={id ? true : false}
            />
            <InputCustom
              type={"text"}
              labelText={t("group.description")}
              errorMessage={
                showError && state.$errors.description.length > 0
                  ? state.$errors.description[0].$message
                  : null
              }
              onBlur={() => setExplicitField("description", true)}
              onChange={(e) => {
                e.persist();
                setData((old) => ({
                  ...old,
                  description: e.target.value,
                }));
              }}
              value={state.$data.description}
              key="description"
            />
          </div>
        </Modal>
      ) : null}
      {/*End Main Modal */}
    </>
  );
};

export default Group;
